import { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  Box,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import SchemaOutlinedIcon from '@mui/icons-material/SchemaOutlined';
import InputIcon from '@mui/icons-material/Input';

import goodalipi from 'src/plugins/goodalipi';
import Logo from './../../Logo';
import { userLogout } from '../../../utils/userLogout';

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const [notifications] = useState([]);
  const loggedInUser = goodalipi.get('user');

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <AppBar
      elevation={0}
      sx={(theme) => ({
        backgroundImage: `url(/static/images/header.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: '#fff',
        color: theme.palette.text.primary,
        borderBottom: `1px solid ${theme.palette.divider}`
      })}
      {...rest}
    >
      <Toolbar sx={{ minHeight: 64, px: { xs: 1.5, sm: 2.5 }, gap: 1.5, position: 'relative' }}>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
          <RouterLink to="/" style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Logo
              src="/static/logos/medibuddyWithName.svg"
              alt="Medibuddy"
              style={{ height: 34, padding: 0, background: 'transparent', borderRadius: 0 }}
            />
          </RouterLink>
          {loggedInUser.presignedUrl ? (
            <Logo src={loggedInUser.presignedUrl} alt="logo" style={{ height: 36 }} />
          ) : null}
        </Box>

        <Typography
          sx={(theme) => ({
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: 24,
            fontWeight: 500,
            color: '#212121',
            pointerEvents: 'none',
            whiteSpace: 'nowrap'
          })}
        >
          {loggedInUser?.companyName}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />
        {/* <Hidden lgDown> */}
        {
          goodalipi.get('user') && goodalipi.get('user').baseProfileData && goodalipi.get('user').baseProfileData.entityId == 11172035 ? (
            <IconButton
              color="inherit"
              onClick={()=>{
              try{
                jsonatorSDK.closeJsonatorPopup();
                jsonatorSDK.openJsonatorPopup();
              }catch(e){
                console.log(e)
              }
              }}
              sx={{
                borderRadius: 2,
                '&:hover': { bgcolor: 'action.hover' }
              }}
            >
              <Badge badgeContent={notifications.length} variant="dot">
                <SchemaOutlinedIcon color="primary" />
              </Badge>
            </IconButton>
        
          ) : null
        }
        <IconButton color="inherit" sx={{ borderRadius: 2, '&:hover': { bgcolor: 'action.hover' } }}>
          <Badge badgeContent={notifications.length} variant="dot">
            <NotificationsIcon color="primary" />
          </Badge>
        </IconButton>
        {/* <RouterLink to="/login"> */}
        <IconButton onClick={userLogout} sx={{ borderRadius: 2, '&:hover': { bgcolor: 'action.hover' } }}>
          <InputIcon color="primary" />
        </IconButton>
        {/* </RouterLink> */}

        {/* </Hidden> */}
        {!isDesktop && (
          <IconButton color="inherit" onClick={onMobileNavOpen} sx={{ borderRadius: 2, '&:hover': { bgcolor: 'action.hover' } }}>
            <MenuIcon color="primary" />
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default DashboardNavbar;
